import styled from 'styled-components'

interface FilterItemProps {
  selected: boolean;
}

export const FilterBar = styled.div`
  display: flex;
  overflow-x: auto;
  padding: 10px 0px;
  position: relative;

  /* Hide scrollbar for Webkit browsers */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for other browsers */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
`;

export const FilterItem = styled.button<FilterItemProps>`
  flex: 0 0 auto;
  margin-right: 10px;
  padding: 6px 16px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.1);
  position: relative

  &:focus {
    outline: none;
  }

  background-color: ${(props) => (props?.selected ? '#EAF5FF' : '')};
  border-color: ${(props) => (props?.selected ? '#0c58b4' : '')};
  border-style: ${(props) => (props?.selected ? 'solid' : '')};
  border-width: ${(props) => (props?.selected ? '1px' : '')};
`;

export const FilterText = styled.text`
  font-weight: 700;
  color: #4A4A4A;
  font-family: 'Lato';
`;